module.exports = __webpack_public_path__ + "img/mortality_toddler_death.828890f7.svg";